
import { Component } from 'react'
import { Link } from 'react-router-dom'
import { RouterProps, withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import { retriveJobApply } from '../../../../insfrastructure/services/job-applies'
import { retrieveCandidate } from '../../../../insfrastructure/services/candidates'
import IntervalModal from './interview-modal'
import RepproveModal from './repprove-modal'
import infoIcon from '../../../../assets/icons/info.png'
import profileIcon from '../../../../assets/icons/male-icon.svg'
import houseIcon from '../../../../assets/icons/house.png'
import emailIcon from '../../../../assets/icons/mail.svg'
import phoneIcon from '../../../../assets/icons/phone.png'
import repproveIcon from '../../../../assets/icons/delete-white.png'
import calendarIcon from '../../../../assets/icons/calendar-white.png'
import downloadIcon from '../../../../assets/icons/document.png'
import './styles.sass'
import moment from 'moment'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { listExpirences } from '../../../../insfrastructure/services/experiences'
import { listCourses } from '../../../../insfrastructure/services/courses'
import { logger } from '../../../../insfrastructure/services/analytics'
import { getCourseKey, getExperienceKey, getSkillKey } from '../../../../insfrastructure/utils/candidate-list-keys'
import { normalizeDateOnlyFromApi } from '../../../../insfrastructure/utils/date-formatter'

class Candidate extends Component<RouterProps> {
    state: any = {
        offer: {
            jobTitle: {
                name: ''
            }
        },
        jobapply: {
            status: ''
        },
        course_progress: {},
        marital_status: {},
        skills_options: [],
        skills: [],
        experiences: [],
        scholarships: [],
        candidate: {},
        em_units: [],
        em_courses: {},
        education_levels: {},
        cnh_categories: {},
        disabilities: {},
        updateCandidateLoading: false,
        renderCallForInterviewModal: false,
        renderRepproveCandidateModal: false,
        downloadCVLoading: false
    }

    async componentDidMount() {
        await this.getStaticValues();
        await this.retriveJob();
        const { jobapply, candidate } = await this.retriveCandidate();
        // Aguardar valores estáticos estarem disponíveis antes de continuar
        await this.listSkills(candidate);
        await this.listExpirences(jobapply, candidate);
        await this.listCourses(jobapply, candidate);
    }

    getStaticValues = async () => {
        try {
            const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
            const marital_status = staticValues.marital_status;
            const skills_options = staticValues.skills;
            const course_progress = staticValues.course_progress;
            const em_units = staticValues.em_unit;
            const em_courses = staticValues.em_course;
            const education_levels = staticValues.education_level;
            const cnh_categories = staticValues.cnh_category;
            const disabilities = staticValues.disability;
            
            this.setState({ marital_status, skills_options, course_progress, em_units, em_courses, education_levels, cnh_categories, disabilities });
        } catch (error: any) {
            logger.error(
                'Erro ao carregar valores estáticos do localStorage',
                error instanceof Error ? error : new Error(String(error)),
                {
                    component: 'Candidate',
                    method: 'getStaticValues',
                    hasStaticValues: !!localStorage.getItem('static_values')
                }
            );
        }
    }

    retriveJob = async () => {
        try {
          const offer = (await listJobs({ id: this.props.params?.offer_id })).data[0];
          this.setState({ offer });
        } catch (error: any) {
            logger.error(
                'Erro ao carregar dados da vaga',
                error instanceof Error ? error : new Error(String(error)),
                {
                    component: 'Candidate',
                    method: 'retriveJob',
                    offer_id: this.props.params?.offer_id,
                    error_response: error?.response?.data || error?.message
                }
            );
        }
    }

    retriveCandidate = async () => {
        try {
          const jobapply = await retriveJobApply(this.props.params?.jobapply_id );
          
          // Log para debug
          console.log('JobApply recebido:', jobapply);
          console.log('candidate_id do jobapply:', jobapply?.candidate_id);
          
          // Se os dados do candidato já vêm no payload do jobapply, usar diretamente
          let candidate = jobapply?.candidate;
          
          // Se não vier no payload, buscar via API (fallback)
          if (!candidate) {
              const candidateId = jobapply?.candidate_id || (jobapply as any)?.candidateId;
              
              if (!candidateId) {
                  logger.error(
                      'candidate_id não encontrado no jobapply',
                      new Error('candidate_id is undefined'),
                      {
                          component: 'Candidate',
                          method: 'retriveCandidate',
                          jobapply_id: this.props.params?.jobapply_id,
                          jobapply_keys: jobapply ? Object.keys(jobapply) : [],
                          jobapply_data: jobapply
                      }
                  );
                  return { jobapply, candidate: null };
              }
              
              console.log('Buscando candidato via API (fallback)...');
              candidate = await retrieveCandidate(candidateId);
          } else {
              console.log('Usando candidato do payload do jobapply');
          }

          console.log('Candidate recebido:', candidate);
          
          this.setState({ jobapply, candidate });
          
          return { jobapply, candidate };
        } catch (error: any) {
            logger.error(
                'Erro ao carregar dados do candidato',
                error instanceof Error ? error : new Error(String(error)),
                {
                    component: 'Candidate',
                    method: 'retriveCandidate',
                    jobapply_id: this.props.params?.jobapply_id,
                    error_response: error?.response?.data || error?.message,
                    has_jobapply: !!this.state.jobapply
                }
            );
            return { jobapply: null, candidate: null };
        }
    }

    listSkills = async (candidateParam?: any) => {
        try {
            // Usar o parâmetro passado ou o estado
            const candidate = candidateParam || this.state.candidate;
            
            // Verificar se candidate.skills existe e é um array antes de usar
            const candidateSkills = candidate?.skills;
            
            // Se skills não estiver disponível ou não for um array, apenas definir como array vazio sem log de warning
            // (pode ser que o candidato não tenha skills cadastradas)
            if (!candidateSkills || !Array.isArray(candidateSkills)) {
                // Só logar warning se o candidate existir mas skills não for um array válido
                if (candidate && candidateSkills !== undefined && !Array.isArray(candidateSkills)) {
                    logger.warn('candidate.skills não é um array válido', {
                        component: 'Candidate',
                        method: 'listSkills',
                        has_candidate: !!candidate,
                        candidate_skills_type: typeof candidateSkills,
                        candidate_skills_value: candidateSkills,
                        skills_options_count: this.state.skills_options?.length || 0
                    });
                }
                this.setState({ skills: [] });
                return;
            }

            // Se skills for um array vazio, apenas definir como vazio
            if (candidateSkills.length === 0) {
                this.setState({ skills: [] });
                return;
            }

            const skills = this.state.skills_options.filter((x: any) => 
                candidateSkills.includes(x.id)
            );

            console.log('Skills encontradas:', { skills_options: this.state.skills_options, candidateSkills, skills });

            this.setState({ skills });
        } catch (error: any) {
            logger.error(
                'Erro ao listar habilidades do candidato',
                error instanceof Error ? error : new Error(String(error)),
                {
                    component: 'Candidate',
                    method: 'listSkills',
                    has_candidate: !!this.state.candidate,
                    skills_options_count: this.state.skills_options?.length || 0
                }
            );
            this.setState({ skills: [] });
        }
    }

    listExpirences = async (jobapplyParam?: any, candidateParam?: any) => {
        try {
            // Usar os parâmetros passados ou o estado
            const jobapply = jobapplyParam || this.state.jobapply;
            const candidate = candidateParam || this.state.candidate;
            
            // Primeiro, verificar se as experiências já vêm no payload do jobapply
            if (jobapply?.experiences && Array.isArray(jobapply.experiences) && jobapply.experiences.length > 0) {
                console.log('Usando experiências do payload do jobapply:', jobapply.experiences);
                
                // Ordenar experiências por data (mais recente primeiro)
                // Empregos sem end_date (atuais) aparecem primeiro
                const sortedExperiences = jobapply.experiences.sort((a: any, b: any) => {
                    // Ambos são empregos atuais, ordenar por data de início (mais recente primeiro)
                    if (!a.end_date && !b.end_date) {
                        return moment(b.start_date).diff(moment(a.start_date));
                    }
                    // a é emprego atual, vem primeiro
                    if (!a.end_date) return -1;
                    // b é emprego atual, vem primeiro
                    if (!b.end_date) return 1;
                    
                    // Ambos têm end_date, ordenar por data de término (mais recente primeiro)
                    return moment(b.end_date).diff(moment(a.end_date));
                });

                this.setState({ experiences: sortedExperiences });
                return;
            }

            // Fallback: buscar experiências via API se não vierem no payload
            // Tentar acessar candidate_id de diferentes formas
            const candidateId = jobapply?.candidate_id 
                || (jobapply as any)?.candidateId
                || candidate?.id;
            
            if (!candidateId) {
                logger.warn('ID do candidato não encontrado para listar experiências', {
                    component: 'Candidate',
                    method: 'listExpirences',
                    has_jobapply: !!jobapply,
                    has_candidate: !!candidate,
                    jobapply_candidate_id: jobapply?.candidate_id,
                    jobapply_keys: jobapply ? Object.keys(jobapply) : [],
                    candidate_id: candidate?.id
                });
                this.setState({ experiences: [] });
                return;
            }

            const experiences = await listExpirences(candidateId);

            console.log('Experiências obtidas via API:', experiences.results);

            // Ordenar experiências por data (mais recente primeiro)
            // Empregos sem end_date (atuais) aparecem primeiro
            const sortedExperiences = experiences.results.sort((a: any, b: any) => {
                // Ambos são empregos atuais, ordenar por data de início (mais recente primeiro)
                if (!a.end_date && !b.end_date) {
                    return moment(b.start_date).diff(moment(a.start_date));
                }
                // a é emprego atual, vem primeiro
                if (!a.end_date) return -1;
                // b é emprego atual, vem primeiro
                if (!b.end_date) return 1;
                
                // Ambos têm end_date, ordenar por data de término (mais recente primeiro)
                return moment(b.end_date).diff(moment(a.end_date));
            });

            this.setState({ experiences: sortedExperiences });
        } catch (error: any) {
            logger.error(
                'Erro ao listar experiências do candidato',
                error instanceof Error ? error : new Error(String(error)),
                {
                    component: 'Candidate',
                    method: 'listExpirences',
                    candidate_id: this.state.jobapply?.candidate_id || this.state.candidate?.id,
                    error_response: error?.response?.data || error?.message
                }
            );
            this.setState({ experiences: [] });
        }
    }

    listCourses = async (jobapplyParam?: any, candidateParam?: any) => {
        try {
            // Usar os parâmetros passados ou o estado
            const jobapply = jobapplyParam || this.state.jobapply;
            const candidate = candidateParam || this.state.candidate;
            
            // Primeiro, verificar se os cursos já vêm no payload do jobapply
            if (jobapply?.courses && Array.isArray(jobapply.courses) && jobapply.courses.length > 0) {
                console.log('Usando cursos do payload do jobapply:', jobapply.courses);
                
                const formatted_courses = jobapply.courses.map((x: any) => {
                    x.em_unit = x.em_unit ? this.state.em_units.filter((y: any) => y.id === x.em_unit)[0]?.name : x.em_unit;
                    x.em_course = x.em_course ? this.state.em_courses[x.em_course] : x.em_course;
                    return x;
                });

                this.setState({ scholarships: formatted_courses });
                return;
            }

            // Fallback: buscar cursos via API se não vierem no payload
            // Tentar acessar candidate_id de diferentes formas
            const candidateId = jobapply?.candidate_id 
                || (jobapply as any)?.candidateId
                || candidate?.id;
            
            if (!candidateId) {
                logger.warn('ID do candidato não encontrado para listar cursos', {
                    component: 'Candidate',
                    method: 'listCourses',
                    has_jobapply: !!jobapply,
                    has_candidate: !!candidate,
                    jobapply_candidate_id: jobapply?.candidate_id,
                    jobapply_keys: jobapply ? Object.keys(jobapply) : [],
                    candidate_id: candidate?.id
                });
                this.setState({ scholarships: [] });
                return;
            }

            const courses = await listCourses(candidateId);

            console.log('Cursos obtidos via API:', courses.results);

            console.log(this.state.em_units);
            

            const formatted_courses = courses.results.map((x) => {
                const foundUnit = x.em_unit ? this.state.em_units.find((y: any) => y.id === x.em_unit) : null;
                x.em_unit = foundUnit ? foundUnit.name : x.em_unit;
                x.em_course = x.em_course ? this.state.em_courses[x.em_course] : x.em_course;

                console.log(x);
                

                return x;
            });

            this.setState({ scholarships: formatted_courses });
        } catch (error: any) {
            logger.error(
                'Erro ao listar cursos do candidato',
                error instanceof Error ? error : new Error(String(error)),
                {
                    component: 'Candidate',
                    method: 'listCourses',
                    candidate_id: this.state.jobapply?.candidate_id || this.state.candidate?.id,
                    error_response: error?.response?.data || error?.message
                }
            );
            this.setState({ scholarships: [] });
        }
    }

    getCandidateAge = (date_of_birth_string: string) => {
        var current_date = moment();
        const normalized = normalizeDateOnlyFromApi(date_of_birth_string);
        var date_of_birth = normalized ? moment(normalized, 'YYYY-MM-DD') : moment(date_of_birth_string);
        var years = current_date.diff(date_of_birth, 'years');
        
        return years;
    }

    toggleCallForInterviewModal = () => {
        this.setState({ renderCallForInterviewModal: !this.state.renderCallForInterviewModal });
    }

    toggleRepproveCandidateModal = () => {
        this.setState({ renderRepproveCandidateModal: !this.state.renderRepproveCandidateModal });
    }
    onCandidateRepproved = async () => {
        this.toggleRepproveCandidateModal();
    }

    onCandidateCalledForInterview = async () => {
        this.toggleCallForInterviewModal();
        this.retriveCandidate();
    }

    downloadCV = async () => {
        try {
            this.setState({ downloadCVLoading: true });
            
            // Tentar diferentes fontes para o ID do candidato
            let candidateId = null;
            
            // 1. Tentar candidate.id
            if (this.state.candidate?.id) {
                candidateId = this.state.candidate.id;
            }
            // 2. Tentar jobapply.candidate_id
            else if (this.state.jobapply?.candidate_id) {
                candidateId = this.state.jobapply.candidate_id;
            }
            // 3. Fallback: tentar recarregar os dados se não encontrou o ID
            else {
                logger.warn('ID do candidato não encontrado, tentando recarregar dados', {
                    component: 'Candidate',
                    method: 'downloadCV',
                    has_jobapply: !!this.state.jobapply,
                    has_candidate: !!this.state.candidate
                });
                await this.retriveCandidate();
                
                // Tentar novamente após recarregar
                if (this.state.candidate?.id) {
                    candidateId = this.state.candidate.id;
                } else if (this.state.jobapply?.candidate_id) {
                    candidateId = this.state.jobapply.candidate_id;
                }
            }
            
            if (!candidateId) {
                throw new Error('ID do candidato não encontrado. Verifique se os dados foram carregados corretamente.');
            }
            
            console.log('Baixando currículo do candidato:', {
                candidateId,
                candidateName: this.state.candidate.full_name,
                jobapplyId: this.state.jobapply.id
            });
            
            // Para empresas: baixar currículo sem validação
            // Empresas podem baixar currículos de candidatos mesmo com perfil incompleto
            const { downloadCandidateCV } = await import('../../../../insfrastructure/services/candidates');
            const blob = await downloadCandidateCV(candidateId);
            
            // Fazer o download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `curriculo_${this.state.candidate.full_name?.replace(/\s+/g, '_') || 'candidato'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
        } catch (error: any) {
            const candidateId = this.state.candidate?.id || this.state.jobapply?.candidate_id;
            
            logger.error(
                'Erro ao baixar currículo do candidato',
                error instanceof Error ? error : new Error(String(error)),
                {
                    component: 'Candidate',
                    method: 'downloadCV',
                    candidate_id: candidateId,
                    error_response: error?.response?.data || error?.message,
                    error_status: error?.response?.status
                }
            );
            
            console.error('Erro ao baixar currículo:', {
                candidateId,
                error: error.response?.data || error.message
            });
            
            // Mostrar mensagem específica do erro se disponível
            const errorMessage = error.message || 'Erro ao baixar o currículo. Tente novamente.';
            alert(errorMessage);
        } finally {
            this.setState({ downloadCVLoading: false });
        }
    }


    getExperiencePeriod = (start_date_string: string, end_date_string: string) => {
        let result = '';

        let current_date = moment();
        let start_date = moment(start_date_string);
        let end_date = moment(end_date_string);
        
        if (!end_date_string || current_date.isBefore(end_date)) {
            const years_in_the_job = current_date.diff(start_date, 'years');

            result = `Atualmente` + (years_in_the_job > 0 ? `(${years_in_the_job} anos)` : '');
        } else {
          result = end_date.format('MM/YYYY')+'';  
        }

        return start_date.format('MM/YYYY') + ' - ' + result;
    }

    getFullAddress = (candidate: any) => {
        const addressParts = [];
        
        // Por questões de privacidade (LGPD), exibimos apenas bairro, cidade e UF
        // O endereço completo (rua, número, complemento) não é necessário para o recrutador
        
        // Adicionar bairro se disponível
        if (candidate.district || candidate.address_district) {
            addressParts.push(candidate.district || candidate.address_district);
        }
        
        // Adicionar cidade se disponível
        if (candidate.city_name || candidate.city) {
            addressParts.push(candidate.city_name || candidate.city);
        }
        
        // Adicionar UF se disponível
        if (candidate.city_uf) {
            addressParts.push(candidate.city_uf);
        }
        
        return addressParts.join(', ');
    }

    render() {
        return (
            <div className='candidate company-page'>
                <div className='block'>
                    <div className='block-header'>
                        <div className='title'>
                            <img src={infoIcon} alt='info-icon' />
                            <h3><Link to={'/offers'}>Vagas {'>'}</Link> <Link to={'/offers/'+this.props.params?.offer_id+'/candidates'}>{this.state.offer?.jobTitle?.name} - Candidatos {'>'}</Link> Candidato</h3>
                        </div>
                        <div className='actions'>
                            {this.state.jobapply.status === 'applied' &&
                            <button className='not-apt-btn' onClick={this.toggleRepproveCandidateModal}>
                                <img src={repproveIcon} alt='repprove-icon' />
                                <span>Não apto</span>
                            </button>}
                            {
                            this.state.jobapply.status === 'applied' &&    
                            <button className='interview-btn' onClick={this.toggleCallForInterviewModal}>
                                <img src={calendarIcon} alt='calendar-icon' />
                                <span>Chamar para entrevista</span>
                            </button>}
                        </div>
                    </div>
                    <div className='info'>
                        <div className='columns'>
                            <div className='column'>
                                <div className='main section'>
                                    <div className='profile-picture-container'>
                                        <img className='profile-picture' alt='profile-picture' src={profileIcon} />
                                    </div>
                                    <h3>{this.state.candidate.full_name}</h3>
                                    {
                                    Object.keys(this.state.marital_status).length > 0 &&
                                    <div>
                                        <p>
                                            {this.state.marital_status[this.state.candidate.marital_status]}
                                            {this.state.candidate.date_of_birth && ', ' + this.getCandidateAge(this.state.candidate.date_of_birth) + ' anos'}
                                        </p>
                                        <p>{this.state.candidate.city_name}, {this.state.candidate.city_uf}</p>
                                        {this.state.candidate.education_level && this.state.education_levels && (
                                            <p>Escolaridade: {this.state.education_levels[this.state.candidate.education_level] || this.state.candidate.education_level}</p>
                                        )}
                                        {this.state.candidate.cnh_category && this.state.cnh_categories && (
                                            <p>Categoria CNH: {this.state.cnh_categories[this.state.candidate.cnh_category] || this.state.candidate.cnh_category}</p>
                                        )}
                                        {this.state.candidate.disability && this.state.disabilities && (
                                            <p>
                                                Deficiência: {this.state.disabilities[this.state.candidate.disability] || this.state.candidate.disability}
                                                {this.state.candidate.disability === 'Outro' && this.state.candidate.expecific_disability && (
                                                    <span> - {this.state.candidate.expecific_disability}</span>
                                                )}
                                            </p>
                                        )}
                                    </div>
                                    }
                                </div>
                                <div className='knowledges section'>
                                    <h3>Habilidades:</h3>
                                    <div className='list'>
                                        {
                                            this.state.skills.map((skill: any, index: number) => {
                                            const key = getSkillKey(skill, index);
                                            return (
                                                <span key={key} className='knowledge'>{skill.name}</span>
                                            );
                                            })                                        }
                                    </div>
                                </div>
                                {/* <div className='abilities section'>
                                    <h3>Conhecimentos:</h3>
                                    <div className='list'>
                                        <span className='ability'>Estudioso</span>
                                    </div>
                                </div> */}
                            </div>
                            <div className='column'>
                                <div className='experiences section'>
                                    <h3>Minhas experiências</h3>
                                    <div className='list'>
                                        {
                                            this.state.experiences.map((experience: any, index: number) => {
                                            const key = getExperienceKey(experience, index);
                                            return (
                                            <div key={key} className='experience'>
                                                <b>{experience.position}</b>
                                                <p>{experience.company_name}</p>
                                                <p>{this.getExperiencePeriod(experience.start_date, experience.end_date)}</p>
                                            </div>
                                            );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='column'>
                                <div className='courses section'>
                                    <h3>Meus cursos</h3>
                                    <div className='list'>
                                        {
                                            this.state.scholarships.map((course: any, index: number) => {
                                            const key = getCourseKey(course, index);
                                            return (
                                            <div key={key} className='course'>
                                                <b>{course.em_course ? course.em_course : course.course_name}</b>
                                                <p>{course.em_unit ? course.em_unit : course.institution}</p>
                                                {/* <p>Campinas, SP</p> */}
                                                <span className={'status '+course.status}>{this.state.course_progress[course.status]}</span>
                                            </div>
                                            );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='basic-info columns section'>
                            <div className='column'>
                                <div className='basic-info-intro'>
                                    <h3>Dados básicos:</h3>
                                    <div className='info-line'>
                                        <img src={phoneIcon} alt='phone-icon' />
                                        <span>{this.state.candidate.mobile}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='column'>
                                <div className='info-line'>
                                    <img src={emailIcon} alt='email-icon' />
                                    <span>{this.state.candidate.email}</span>
                                </div>
                            </div>
                            <div className='column'>
                                <div className='info-line'>
                                    <img src={houseIcon} alt='house-icon' />
                                    <span>
                                        {this.getFullAddress(this.state.candidate)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='download-cv-section'>
                        <button 
                            className='download-cv-btn' 
                            onClick={this.downloadCV}
                            disabled={this.state.downloadCVLoading}
                        >
                            <img src={downloadIcon} alt='download-icon' />
                            <span>{this.state.downloadCVLoading ? 'Baixando...' : 'Baixar currículo'}</span>
                        </button>
                    </div>
                </div>
                <IntervalModal
                render={this.state.renderCallForInterviewModal}
                candidate={this.state.candidate}
                jobapply_id={this.props.params?.jobapply_id}
                onClose={this.toggleCallForInterviewModal}
                onSubmitted={this.onCandidateCalledForInterview} />
                <RepproveModal
                status='not_fit'
                render={this.state.renderRepproveCandidateModal}
                candidate={this.state.candidate}
                jobapply_id={this.props.params?.jobapply_id}
                onClose={this.toggleRepproveCandidateModal}
                onSubmitted={this.onCandidateRepproved} />
                
            </div>
        )
    }
}

export default withRouter(Candidate)
